import { useState, useEffect } from 'react';


import rym from '../assets/rym.jpeg';
import equipo from '../assets/equipo.jpeg';

const AboutPage = () => {
  const timelineEvents = [
    {
      year: "1997",
      title: "Surge Componentes Industriales",
      description: "Nacemos con la visión de transformar la industria a través de la automatización, iniciando como un distribuidor local de componentes clave.",
      image: "/timeline-2008.jpg"
    },
    {
      year: "2001",
      title: "Pasamos a ser R&M Componentes Industriales SRL",
      description: "Ampliamos nuestra oferta de productos e iniciamos alianzas con marcas internacionales líderes, consolidando nuestra posición en el mercado. Importaciones inciales de Puerto Rico y Floria",
      image: "/timeline-2012.jpg"
    },
    {
      year: "2007",
      title: "Importaciones desde Sur Corea, Panama, China y Taiwan",
      description: "nota",
      image: "/timeline-2016.jpg"
    },
    {
      year: "2014",
      title: "Lanzamiento de Servicios de Ingeniería",
      description: "Incorporamos un equipo de ingenieros especializados para ofrecer asesoría técnica, diseño de sistemas y soporte post-venta, brindando soluciones integrales.",
      image: "/timeline-2019.jpg"
    },
    {
      year: "2016",
      title: "Expansión Regional y Nuevas Oficinas",
      description: "Abrimos nuevas oficinas y centros de distribución, expandiendo nuestra cobertura y capacidad logística para atender a más clientes en la región.",
      image: "/timeline-2022.jpg"
    },
    {
      year: "2021",
      title: "Innovación y Futuro de la Automatización",
      description: "Continuamos invirtiendo en nuevas tecnologías y capacitación, preparándonos para los desafíos futuros de la industria 4.0 y la automatización avanzada.",
      image: "/timeline-2024.jpg"
    },
    {
      year: "2025",
      title: "Expansión Regional y Nuevas Oficinas",
      description: "Abrimos nuevas oficinas y centros de distribución, expandiendo nuestra cobertura y capacidad logística para atender a más clientes en la región.",
      image: "/timeline-2022.jpg"
    },
    {
      year: "2024",
      title: "Innovación y Futuro de la Automatización",
      description: "Continuamos invirtiendo en nuevas tecnologías y capacitación, preparándonos para los desafíos futuros de la industria 4.0 y la automatización avanzada.",
      image: "/timeline-2024.jpg"
    }
  ];
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          element.classList.add('opacity-100', 'translate-y-0', 'scale-100');
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-gray-900 mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
          Sobre <span className="text-red-600">Nosotros</span>
        </h1>

        {/* Historia */}
        <div className="md:flex items-center mb-20 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-100">
          <div className="md:w-1/2 mb-12 md:mb-0 md:pr-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">Nuestra <span className="text-red-600">Historia</span></h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
            R & M COMPONENTES INDUSTRIALES, S.R.L. surge de
            la idea del Sr. Rigoberto A. Rosario, quien en ese
            momento, con amplia experiencia en el área, en
            empresas de la Zona Franca de Haina, identificar las
            carencias y necesidades que existían en los servicios
            de automatización y controles para las industrias.</p>
            <p className="text-lg text-gray-700 leading-relaxed">
            En el año 1997, decide dar vida al proyecto de R&M
            COMPONENTES INDUSTRIALES, S.R.L. empresa
            dedicada a la importación, ventas, y servicios de
            controles eléctricos industriales y automatización, para asi ayudar a los
            fabricantes a alcanzar el éxito con soluciones de
            controles de automatización e instrumentación
            industrial diseñadas para proporcionar a los clientes
            una ventaja competitiva.</p>
            <p className="text-lg text-gray-700 leading-relaxed">
            Desde entonces somos una empresa dedicada a la distribución de
            componentes y soluciones para la automatización
            industrial. Con una estructura sólida y más de 6
            departamentos especializados, convirtiendonos en un aliado
            estratégico para el desarrollo y mantenimiento de
            sistemas industriales eficientes y modernos en la industria nacional e internacional.</p>
          </div>
          <div className="md:w-1/2 relative">
            <img 
              src={rym}
              alt="Historia de R&M Componentes Industriales"
              className="rounded-xl shadow-2xl w-full h-auto transform rotate-3 hover:rotate-0 transition-transform duration-500"
            />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-red-600 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
            <div className="absolute -top-8 -right-8 w-48 h-48 bg-blue-600 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
          </div>
        </div>

        {/* Línea de Tiempo */}
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-200">
          Nuestra <span className="text-red-600">Trayectoria</span>
        </h2>
        <div className="relative wrap overflow-hidden p-10 h-full">
          <div className="border-2-2 absolute border-opacity-20 border-gray-700 h-full border" style={{ left: '50%' }}></div>
          {timelineEvents.map((event, index) => (
            <div 
              key={index} 
              className={`mb-8 flex justify-between items-center w-full ${index % 2 === 0 ? 'flex-row-reverse left-timeline' : 'right-timeline'} animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-${300 + index * 100}`}
            >
              <div className="order-1 w-5/12"></div>
              <div className="z-20 flex items-center order-1 bg-red-600 shadow-xl w-12 h-12 rounded-full"> {/* Aumentado el tamaño del círculo */}
                <h1 className="mx-auto font-semibold text-lg text-white">{event.year}</h1> {/* Texto del año */}
              </div>
              <div className={`order-1 bg-white rounded-lg shadow-xl w-5/12 px-6 py-4 ${index % 2 === 0 ? 'text-right' : 'text-left'}`}>
                <h3 className="mb-3 font-bold text-gray-800 text-xl">{event.title}</h3>
                <p className="text-sm leading-snug tracking-wide text-gray-600 text-opacity-100">{event.description}</p>
                {event.image && (
                  <img src={event.image} alt={event.title} className="mt-4 rounded-lg shadow-md w-full h-auto" />
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Misión, Visión, Valores */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-20">
          <div className="bg-white p-10 rounded-xl shadow-xl animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-200 transform hover:scale-105">
            <h3 className="text-3xl font-bold text-red-600 mb-4">Misión</h3>
            <p className="text-gray-700 leading-relaxed">
            Ofrecer productos de alta calidad y
soluciones confiables en
automatización industrial,
brindando un servicio personalizado
y técnico que impulse el crecimiento
de nuestros clientes. </p>
          </div>
          <div className="bg-white p-10 rounded-xl shadow-xl animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-300 transform hover:scale-105">
            <h3 className="text-3xl font-bold text-red-600 mb-4">Visión</h3>
            <p className="text-gray-700 leading-relaxed">
            Ser la empresa líder en soluciones
industriales integrales, reconocida
por la innovación, confianza y
compromiso con el desarrollo
tecnológico de nuestros clientes.</p>
          </div>
          <div className="bg-white p-10 rounded-xl shadow-xl animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-400 transform hover:scale-105">
            <h3 className="text-3xl font-bold text-red-600 mb-4">Valores</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-3 leading-relaxed">
              <li><span className="font-semibold">Integridad:</span> Actuamos con honestidad y transparencia.</li>
              <li><span className="font-semibold">Innovación:</span> Buscamos soluciones creativas y de vanguardia.</li>
              <li><span className="font-semibold">Compromiso:</span> Dedicación total a nuestros clientes y proyectos.</li>
              <li><span className="font-semibold">Excelencia:</span> Superamos las expectativas en cada entrega.</li>
              <li><span className="font-semibold">Orientación al Cliente:</span> El cliente es el centro de todo lo que hacemos.</li>
            </ul>
          </div>
        </div>

        {/* Equipo */}
        <div className="text-center animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 delay-500">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">Nuestro <span className="text-red-600">Equipo</span></h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-12 leading-relaxed">
            Contamos con un equipo multidisciplinario de ingenieros y especialistas altamente capacitados, dedicados a ofrecerte el mejor soporte y asesoría, garantizando el éxito de tus proyectos.
          </p>
          <img 
            src={equipo}
            alt="Equipo de R&M Componentes Industriales"
            className="rounded-xl shadow-2xl w-full max-w-4xl mx-auto h-auto transform -rotate-2 hover:rotate-0 transition-transform duration-500"
          />
        </div>
      </div>
    </div>
  );
};
export default AboutPage;